/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Check_In_Not_Eligible_TitleInputs */

const en_check_in_not_eligible_title = /** @type {(inputs: Check_In_Not_Eligible_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promotion unavailable`)
};

const es_check_in_not_eligible_title = /** @type {(inputs: Check_In_Not_Eligible_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promocion no disponible`)
};

/**
* | output |
* | --- |
* | "Promotion unavailable" |
*
* @param {Check_In_Not_Eligible_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const check_in_not_eligible_title = /** @type {((inputs?: Check_In_Not_Eligible_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Check_In_Not_Eligible_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_check_in_not_eligible_title(inputs)
	return es_check_in_not_eligible_title(inputs)
});